import React from 'react';
import useFadeIn from '../hooks/useFadeIn';

const products = [
  {
    num: '01',
    name: <><em>Monk</em>Care</>,
    status: 'Live',
    statusColor: { fg: '#059669', border: 'rgba(5,150,105,0.3)' },
    domain: 'Healthcare',
    desc: 'Patient record management, appointment scheduling, and clinical workflow automation. Built for modern clinics that are tired of juggling five tools to do one job.',
    href: 'https://monkcare.oldmonktech.com',
    accent: null,
  },
  {
    num: '02',
    name: <><em>Secure</em>Monk</>,
    status: 'Live',
    statusColor: { fg: '#059669', border: 'rgba(5,150,105,0.3)' },
    domain: 'Security',
    desc: 'Security monitoring and incident response for teams that can\'t afford to find out about a breach from a customer. Continuous threat assessment, compliance automation.',
    href: 'https://secure.oldmonktech.com',
    accent: null,
  },
  {
    num: '03',
    name: <><em>Pramaan</em></>,
    status: 'Live',
    statusColor: { fg: '#f97316', border: 'rgba(249,115,22,0.3)' },
    domain: 'Legal Tech · India',
    desc: 'Digital document execution built for India — combining signing, identity verification, and evidence into a single workflow. No more printing, scanning, or praying the other party remembers to sign.',
    href: 'https://pramaan.oldmonktech.com',
    accent: { primary: '#f97316', lt: '#fb923c', dim: 'rgba(249,115,22,0.10)' },
  },
  {
    num: '04',
    name: <><em>Stay</em>Awake</>,
    status: 'macOS',
    statusColor: { fg: '#a78bfa', border: 'rgba(167,139,250,0.3)' },
    domain: 'Utility · macOS',
    desc: 'Keeps your Mac awake without touching system settings. Shift the mouse every 10s or 15s, or just block sleep outright — one click, no fuss. Tiny, offline, no permissions needed.',
    href: 'https://stayawake.oldmonktech.com',
    accent: { primary: '#a78bfa', lt: '#c4b5fd', dim: 'rgba(167,139,250,0.10)' },
  },
];

export default function Products() {
  const [ref, visible] = useFadeIn(0.1);

  return (
    <section id="products" className="products">
      <div className="products__header">
        <div>
          <span className="section-label">Our Products</span>
          <h2 className="products__title">
            Things we make<br />and <em>stand behind.</em>
          </h2>
        </div>
        <p style={{ fontFamily: 'var(--font-mono)', fontSize: '0.8rem', color: 'var(--text-dim)', maxWidth: '320px', lineHeight: '1.8' }}>
          Built by us, run by us, improved constantly. Not demos, not decks — software you can actually open in a browser.
        </p>
      </div>

      <div ref={ref} className={`products__grid fade-hidden ${visible ? 'fade-visible' : ''}`}>
        {products.map((p, i) => {
          const a = p.accent;
          const cardStyle = a ? {
            '--card-accent':     a.primary,
            '--card-accent-lt':  a.lt,
            '--card-accent-dim': a.dim,
          } : {};

          return (
            <div key={i} className="product-card" style={cardStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
                <span className="product-card__num">{p.num} ──────</span>
                <span style={{
                  fontFamily: 'var(--font-mono)', fontSize: '0.6rem', letterSpacing: '0.1em',
                  color: p.statusColor.fg, border: `1px solid ${p.statusColor.border}`,
                  padding: '0.2rem 0.6rem', borderRadius: '2px'
                }}>● {p.status}</span>
              </div>

              <h3 className="product-card__name" style={a ? { color: '#fff' } : {}}>
                {p.name}
              </h3>

              <div style={{
                display: 'inline-block',
                fontFamily: 'var(--font-mono)', fontSize: '0.6rem',
                letterSpacing: '0.14em', textTransform: 'uppercase',
                color: a ? a.primary : 'var(--amber)',
                borderBottom: `1px solid ${a ? a.dim : 'var(--amber-dim)'}`,
                paddingBottom: '0.2rem',
                marginBottom: '1rem',
              }}>
                {p.domain}
              </div>

              <p className="product-card__desc">{p.desc}</p>

              <a href={p.href} target="_blank" rel="noopener noreferrer"
                className="product-card__link"
                style={a ? { color: a.primary } : {}}>
                Visit ↗
              </a>
            </div>
          );
        })}
      </div>
    </section>
  );
}
